import { render, staticRenderFns } from "./ToCustomer.vue?vue&type=template&id=324688ee&"
import script from "./ToCustomer.vue?vue&type=script&lang=ts&"
export * from "./ToCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports